import {handleActions} from 'redux-actions';
import {createReducer} from "../baseReducer/baseReducer";


// ------------------------------------
// Constants
// ------------------------------------

export const { reducers, initialState, actions } = createReducer(
    "vehicleTypes",
    "vehicle_type",
    "VehicleTypeForm",
    "/vehicle-types",
);

export default handleActions(reducers, initialState);
